import * as React from 'react';
import styles from './EuGrantBanner.module';

export interface EuGrantBannerProps {
}

const EuGrantBanner: React.FC<EuGrantBannerProps> = ({ }) => {

    const [imgSrc] = React.useState('/assets/images/eu_grant_banner.png');

    return (
        <div className={styles.euBannerContainer}>
            
                <p className={styles.euParagraph}>Holo4Labs uzyskało dofinansowanie z Unii Europejskiej na projekt
                    „Prace badawczo-rozwojowe przedsiębiorstwa Holo4Labs w celu utworzenia rozwiązania do automatyzacji procesu pipetowania w laboratorium”.

                </p>

                <p className={styles.euParagraph}>Projekt realizujemy, aby opracować innowacyjny system wspierający proces pipetowania w laboratoriach z wykorzystaniem technologii Rozszerzonej Rzeczywistości (AR).
                    Rozwiązanie będzie działało na różnych typach okularów AR, korzystając z algorytmów rozpoznawania przedmiotów oraz komunikacji Bluetooth w celu pełnej automatyzacji procesu.</p>

                <p className={styles.euParagraph}>
                    W projekcie planujemy przeprowadzić prace badawczo-rozwojowe, opracować prototyp i przetestować go w warunkach laboratoryjnych, a następnie przygotować rozwiązanie do wdrożenia w branżach takich jak:

                    <ul>
                        <li>laboratoria badawcze</li>
                        <li>działy kontroli jakości (QC) w sektorze farmaceutycznym i medycznym</li>
                        <li>laboratoria w przemyśle spożywczym i innych branżach wymagających wysokiej precyzji</li>
                    </ul>

                </p>

                <p className={styles.euParagraph}>
                    Dzięki projektowi laboranci i technicy zyskają narzędzie, które pozwoli:
                    <ul>
                        <li>zredukować liczbę błędów</li>
                        <li>przyspieszyć realizację procedur</li>
                        <li>zwiększyć ergonomię i bezpieczeństwo pracy</li>
                    </ul>

                </p>

                <p className={styles.euParagraph}>
                    Efektem projektu będzie powstanie innowacyjnego rozwiązania AR, które poprawi jakość i efektywność procesów laboratoryjnych oraz przyczyni się do standaryzacji pracy w laboratoriach.
                </p>
                <p className={styles.euParagraph}>
                    Wartość projektu: 1 193 801,42 PLN
                    Wysokość wkładu z Funduszy Europejskich: 763 226,00 PLN
                </p>

                <img className={ styles.euBannerImage } src={imgSrc}>
                </img>
            </div>
           
    );
};

export default EuGrantBanner;
